import { appColors } from '../Config/Theme';
import { IncidentType } from '../Types/enums';

/** Semantic color for a progress percentage. Red is NOT used for low progress. */
export const getProgressColor = (pct: number): string => {
  if (pct >= 90) return appColors.status.success;
  if (pct >= 70) return appColors.primary.main;
  return '#F9A825'; // amber — low progress is not an emergency
};

const INCIDENT_TYPE_LABELS: Record<string, string> = {
  [IncidentType.Drill]: 'Drill',
  [IncidentType.Fire]: 'Fire',
  [IncidentType.Weather]: 'Weather',
  [IncidentType.Medical]: 'Medical',
  [IncidentType.Security]: 'Security',
  [IncidentType.Hazmat]: 'Hazmat',
};

/** Human-readable label for an incident type string. */
export const getIncidentTypeLabel = (type?: string | number | null): string | undefined => {
  if (type == null || type === '') return 'Not selected';
  if (typeof type === 'number') {
    return ['Drill', 'Fire', 'Weather', 'Medical', 'Security', 'Hazmat'][type];
  }
  const key = String(type).toLowerCase();
  return INCIDENT_TYPE_LABELS[key];
};
